import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import '../Workflow.scss'
import WorkflowTask from '../../../../../components/library/workflow-tasks/WorkflowTask'
import { useTaskStatus } from '../../hooks/useTaskStatusHook';
import { WorkflowTasks } from '../../../services/WorkflowTasks';
import WorkflowTaskDescriptionWithHelp from '../../../../../components/library/workflow-tasks/WorkflowTaskDescriptionWithHelp';
import HrbTranslate from '../../../../../components/language/HrbTranslate'
import { TaskStatus } from '../../../services/TaskStatus';
import { useWorkflowState } from '../../hooks/useWorkflowStateHook';
import VerticalNameChildren from '../../../../../components/library/layout/VerticalNameChildren';
import EmdashText from '../../../../../components/library/common/EmdashText';
import DateTime from '../../../../../components/library/common/DateTime';
import { useTicketState } from '../../hooks/useTicketStateHook';
import classnames from 'classnames';
import ManualPaymentRteTask from './ManualPaymentRteTask';


const PaymentRteTask = (props) => {
    const ticketIsOpen = useTicketState(props.ticket);
    let tasks = ([WorkflowTasks.PAYMENT_RECEIVED]);
    const [completion, setCompletion] = useState({});
    const [completionData, setCompletionData] = useState({});
    const [baseStatus, taskCompletions] = useTaskStatus(props.ticket, tasks);
    const [status, setStatus] = useState(baseStatus);
    const stateTasks = useWorkflowState(props.ticket);
    const [hasCompletionError, setHasCompletionError] = useState(false);
    const [paymentType, setPaymentType] = useState(null);

    useEffect(() => {
        let tcs = taskCompletions || [];
        let completionTask = tcs.find(x => x.status !== TaskStatus.INVALID
            && x.workflowTaskId === WorkflowTasks.PAYMENT_RECEIVED);
        
        var bStatus = baseStatus;
        if (baseStatus !== TaskStatus.COMPLETE && (props.ticket)) { 
            var returnPrepared = props.ticket.taskCompletionStates.find(tcs =>
                tcs.workflowTaskId === WorkflowTasks.PAYMENT_PREPARED && tcs.status !== TaskStatus.INVALID);

            if (returnPrepared && returnPrepared.status === TaskStatus.COMPLETE) {
                bStatus = TaskStatus.IN_PROGRESS;
            }
            if (completionTask && completionTask.status === TaskStatus.COMPLETE) {
                setCompletion(completionTask);
                var cdata = JSON.parse(completionTask.completionData);
                setCompletionData(cdata);
                bStatus = TaskStatus.COMPLETE;
                if (cdata.PaymentType)
                { 
                    setPaymentType(cdata.PaymentType);
                }
            }
        }

        setStatus(hasCompletionError ? TaskStatus.ERROR : bStatus);
    }, [baseStatus, stateTasks, hasCompletionError, taskCompletions])
    
    const getPaymentConfirmedDate = () => {
        var completion, data, cs;

        cs = taskCompletions.filter(c => c.status === TaskStatus.COMPLETE && c.workflowTaskId === WorkflowTasks.PAYMENT_RECEIVED);
        completion = cs.length > 0 ? cs[0] : null;

        if (completion && completion.completionData) {
            data = JSON.parse(completion.completionData);                 
            return (data || {}).PaymentDate;
        }
    }

    const handleHasCompletionErrorChange = (newHasCompletionError) => {
        setHasCompletionError(newHasCompletionError)
    }

    return (
        <WorkflowTask status={status} taskId={WorkflowTasks.PAYMENT_RECEIVED_RTE}>
            <div className='columns'>
                <WorkflowTaskDescriptionWithHelp
                    helpKey='0ProSupport/VDOPro/PaymentReview.htm'
                    descriptions={['PaymentRteTask.OnlinePaymentDescription']}
                />
            </div>
            <div className='columns prep-section'>
                <div className='column is-offset-1 is-10'>
                    <div className='prep-border' />
                </div>
            </div>
            <ManualPaymentRteTask ticket={props.ticket} disabled={!ticketIsOpen} onHasCompletionErrorChange={handleHasCompletionErrorChange} />
            <div className='columns'>
                <div className='column is-10 is-offset-1 prep-border small-margins' />
            </div>
            <div className='columns'>
                <div className={classnames('column is-offset-1', 'is-10')}>
                    <VerticalNameChildren
                        textKey="PaymentRteTask.PaymentConfirmedOn"
                        loading={!props.ticket}>
                        <p className='p1 medium-weight'>
                            <DateTime dateAndTime includeSeconds value={getPaymentConfirmedDate()} fallbackValue={<EmdashText />} />
                        </p>
                        { status === TaskStatus.COMPLETE && paymentType === "ONLINE" &&
                            <p className='p1 medium-weight'>
                                <HrbTranslate text='PaymentRteTask.OnlinePayment' />
                            </p>
                        }
                        { status === TaskStatus.COMPLETE && paymentType !== "ONLINE" &&
                            <p className='p1 medium-weight'>
                                <HrbTranslate text='PaymentRteTask.ManualPayment' />
                            </p>
                        }
                    </VerticalNameChildren>
                </div>
            </div>
        </WorkflowTask>
    );
}

PaymentRteTask.whyDidYouRender = false;

PaymentRteTask.propTypes = {
    ticket: PropTypes.object
}

export default PaymentRteTask